/* TODO: t() */
import React, { PureComponent } from 'react';
import { View, StyleSheet, ViewProps } from 'react-native';

import Text from '../Text';

type Props = {
  children: React.ReactNode;
  style?: StyleSet;
  title?: string;
  onMouseEnter?: ViewProps['onMouseEnter'];
  onMouseLeave?: ViewProps['onMouseLeave'];
};

class DataTableCell extends PureComponent<Props> {
  render() {
    let { children, style, title, ...otherProps } = this.props;
    return (
      <View style={[styles.root, style]} {...otherProps}>
        <Text type="label" numberOfLines={1} title={title} style={styles.label}>
          {children}
        </Text>
      </View>
    );
  }
}

let styles = StyleSheet.create({
  root: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  label: {
    flex: 1,
  },
});

export default DataTableCell;
